import { configureStore } from "@reduxjs/toolkit";

// Reducer
const initialState = {
    count: 0,
    userInfo: {
        name: 'test',
        mark: 100
    }
};

const counterReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'INCREMENT':
            return { ...state, count: state.count + action.payload };
        case 'DECREMENT':
            return { ...state, count: state.count - action.payload };
        default:
            return state;
    }
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SETUSERINFO':
            return { ...state, userInfo: action.payload };
        default:
            return state;
    }
};

// Store Configuration
const store = configureStore({
    reducer: {
        user:userReducer,
        counter: counterReducer,
    }
});

export default store;
